<template>
  <div id="csContainer">
      <div class="fogdiv">
          <el-checkbox class="shadow" size="small " v-model="checked" label="大雾" border></el-checkbox>
      </div>

  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'fog',
        data(){
            return{
                checked: false,
                viewer: null
            }
        },
        watch:{
            checked:function (val) {
                this.viewer.scene.fog.enabled = val;
            }
        },
        mounted(){
            this.init();
        },

        methods:{
            init(){
                let vm = util.getViewer("csContainer");
                this.viewer = vm;
                this.viewer.scene.fog.enabled = false;
                let camera = this.viewer.camera;
                camera.setView({
                    destination : Cesium.Cartesian3.fromDegrees(-75.5847, 40.0397, 500.0),
                    orientation: {
                        heading : -Cesium.Math.PI_OVER_TWO,
                        pitch : 0.12,
                        roll : 0.0
                    }
                });

            },



        }
    }
</script>
<style scoped>
  .fogdiv {
      position: absolute;
      margin-left: 25px;
      margin-top: 7px;
      z-index: 999;
      background-color: rgba(0, 0, 0, 0.5);
  }
  .shadow{
      color:white !important;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }

</style>
